<template>
  <div class="py-4">
    <div v-if="title" class="mb-2.5 flex items-baseline">
      <p
        :class="cn('ui-text-m mr-1.5 font-normal capitalize', labelClass)"
        :data-e2e-item="`${block.sku}-filter-group-${block.view_type}`"
      >
        {{ title }}:
      </p>
    </div>
    <div class="grid gap-2.5" :class="gridSizeClasses">
      <button
        v-for="item in block.materials"
        :key="item.id"
        class="flex min-h-12.5 w-full items-center justify-center border px-4 py-2 text-xs disabled:border-gray-10 disabled:bg-gray-5 disabled:text-gray-30"
        :class="
          cn(
            [selectedItem?.id === item.id ? 'border-red-80' : 'border-gray-10'],
            {
              'border-gray-10 bg-gray-5 text-gray-30':
                item.disabled && disabledButClickable,
            },
          )
        "
        :disabled="!skipDisable && item.disabled && !disabledButClickable"
        :data-e2e-item="`${item.sku}-filter-${block.view_type}`"
        @click="onFilterClick(block.slug, item)"
      >
        {{ item?.currentTranslation?.title }}
      </button>
    </div>
    <SharedFieldHint :message="errorMessage" error />
    <slot name="additional" />
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate";
import {
  IProductMaterialFilterEvent,
  IProductMaterialFilterProps,
  MaterialData,
} from "ecom-types";

const props = defineProps<
  IProductMaterialFilterProps & {
    skipDisable?: boolean;
    disabledButClickable?: boolean;
  }
>();

const emit = defineEmits<{
  (e: "filter", value: IProductMaterialFilterEvent): void;
}>();

const { errorMessage, setValue } = useField(props.block?.slug, undefined, {
  initialValue: props.selectedItem?.sku,
});

watch(
  () => props.selectedItem,
  () => {
    setValue(props.selectedItem?.sku || "");
  },
  { deep: true },
);

const gridSizeClasses = computed(() => {
  if (props.block.view_type === filterViewType.button_big) {
    return "grid-cols-3 lg:grid-cols-[repeat(auto-fit,minmax(100px,auto))]";
  } else {
    return "grid-cols-5 lg:grid-cols-[repeat(auto-fill,minmax(64px,auto))]";
  }
});

function onFilterClick(slug: string, item: MaterialData) {
  setValue(item.sku);
  emit("filter", { slug, item });
}
</script>
